import {Component, Injector} from '@angular/core';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {TasksApiService} from '../../../../../Services/Api/Tasks/General/tasks-api.service';
import {TaskDto} from '../../../../../Models/Tasks/General/task.interface';
import {TaskFilters} from '../../../../../Models/Tasks/General/task-filters.model';
import {TaskActionsEnum} from '../../../../../Shared/Enum/task-actions.enum';

@Component({
  selector: 'app-purchases-scheduled-pendents-widget',
  templateUrl: './purchases-scheduled-pendents-widget.component.html',
  styleUrls: ['./purchases-scheduled-pendents-widget.component.scss'],
  standalone: false
})
export class PurchasesScheduledPendentsWidgetComponent extends WidgetDataControllerComponent<number> {

  override fakeData: number = 3;

  get widgetData(): number {
    return this.data || this.data === 0 ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected tasksService: TasksApiService,
  ) {
    super(injector, tasksService);
  }


  /**
   * Obtener las compras programadas pendientes
   *
   */
  override setData(data: TaskDto[]) {
    this.data = data.filter((item) => !item.cerrado && item.action && item.id_subtipo === TaskActionsEnum.order)?.length;
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    const filters: TaskFilters = new TaskFilters();
    filters.id_local = this.widgetsManager.filters?.local.id || 0;

    return this.tasksService.getTasks(filters, false);
  }

}
